document.addEventListener('DOMContentLoaded', () => {

    // 1. Product Gallery Swap
    const mainImage = document.getElementById('mainImage');
    const thumbnails = document.querySelectorAll('.gallery-thumb');

    if (mainImage && thumbnails.length > 0) {
        thumbnails.forEach(thumb => {
            thumb.addEventListener('click', () => {
                const img = thumb.querySelector('img');
                if (img) {
                    mainImage.src = img.src;
                    thumbnails.forEach(t => {
                        t.classList.add('opacity-100');                        
                    });
                    thumb.classList.remove('opacity-100');
                }
            });
        });
    }

    // 2. FAQ Accordion — styled cards (open = dark green, closed = outlined)
    const faqItems = document.querySelectorAll('.faq-item');

    faqItems.forEach(item => {
        item.addEventListener('toggle', () => {
            const summary = item.querySelector('summary');
            const questionSpan = summary ? summary.querySelector('span:first-child') : null;
            const icon = summary ? summary.querySelector('span:last-child') : null;
            const body = item.querySelector('summary + div');

            if (item.classList.contains('faq-mini')) {
                if (icon) {
                    icon.innerHTML = item.open ? '&ndash;' : '+';
                }
                return;
            }

            if (item.open) {
                summary.classList.remove('bg-bglight', 'border', 'border-primary/20', 'hover:border-primary/40');
                summary.classList.add('bg-[#2B4832]', 'rounded-b-none');
                if (questionSpan) {
                    questionSpan.classList.remove('text-primary', 'font-bold');
                    questionSpan.classList.add('text-secondary', 'font-black');
                }
                if (icon) {
                    icon.classList.remove('text-primary');
                    icon.classList.add('text-white');
                    icon.innerHTML = '&ndash;';
                }
                if (body) {
                    body.classList.remove('border', 'border-t-0', 'border-primary/20', 'bg-white/50', 'text-primary/70');
                    body.classList.add('bg-[#2B4832]', 'text-white/80');
                }
            } else {
                summary.classList.add('bg-bglight', 'border', 'border-primary', 'hover:border-primary');
                summary.classList.remove('bg-[#2B4832]', 'rounded-b-none');
                if (questionSpan) {
                    questionSpan.classList.add('text-primary', 'font-bold');
                    questionSpan.classList.remove('text-secondary', 'font-black');
                }
                if (icon) {
                    icon.classList.add('text-primary');
                    icon.classList.remove('text-white');
                    icon.innerHTML = '+';
                }
                if (body) {
                    body.classList.add('border', 'border-t-0', 'border-primary/20', 'bg-white/50', 'text-primary/70');
                    body.classList.remove('bg-[#2B4832]', 'text-white/80');
                }
            }
        });

        item.addEventListener('toggle', () => {
            if (item.open) {
                faqItems.forEach(other => {
                    if (other !== item && other.open) {
                        other.removeAttribute('open');
                        other.dispatchEvent(new Event('toggle'));
                    }
                });
            }
        });
    });

    // 3. Smooth scrolling for anchor links
    document.querySelectorAll('a[href^="#"], a[href^="/#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            const href = this.getAttribute('href');
            const targetId = href.includes('#') ? href.split('#')[1] : null;
            
            if (targetId) {
                const targetElement = document.getElementById(targetId);
                if (targetElement) {
                    e.preventDefault();
                    targetElement.scrollIntoView({ behavior: 'smooth' });
                }
            }
        });
    });

    // 4. Video Lightbox Logic
    const lightbox = document.getElementById('videoLightbox');
    const video = document.getElementById('lightboxVideo');
    const closeBtn = document.getElementById('closeLightbox');
    const videoItems = document.querySelectorAll('[data-video-url]');

    if (lightbox && video && videoItems.length > 0) {
        videoItems.forEach(item => {
            item.addEventListener('click', (e) => {
                const url = item.getAttribute('data-video-url');
                if (url) {
                    video.src = url;
                    lightbox.classList.remove('hidden');
                    document.body.style.overflow = 'hidden';
                    video.play();
                }
            });
        });

        const closeLightbox = () => {
            lightbox.classList.add('hidden');
            document.body.style.overflow = '';
            video.pause();
            video.src = "";
        };

        if (closeBtn) closeBtn.addEventListener('click', closeLightbox);

        lightbox.addEventListener('click', (e) => {
            if (e.target === lightbox) closeLightbox();
        });

        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && !lightbox.classList.contains('hidden')) {
                closeLightbox();
            }
        });
    }

    // 5. Purchase Option Toggle
    const radioSubscribe = document.getElementById('purchase-subscribe');
    const radioOnetime = document.getElementById('purchase-onetime');
    const subBenefits = document.getElementById('sub-benefits');

    function updateSubBenefits() {
        if (!subBenefits) return;
        if (radioSubscribe && radioSubscribe.checked) {
            subBenefits.classList.remove('hidden');
        } else {
            subBenefits.classList.add('hidden');
        }
    }

    if (radioSubscribe) radioSubscribe.addEventListener('change', updateSubBenefits);
    if (radioOnetime) radioOnetime.addEventListener('change', updateSubBenefits);
    updateSubBenefits();

    // 6. Contact Form Spinner Logic
    const contactForm = document.getElementById('ContactForm');
    const contactBtn = document.getElementById('ContactSubmit');
    const contactBtnText = document.getElementById('ContactBtnText');
    const contactIcon = document.getElementById('ContactIcon');
    const contactSpinner = document.getElementById('ContactSpinner');

    if (contactForm && contactBtn) {
        contactForm.addEventListener('submit', () => {
            contactBtn.disabled = true;
            contactBtn.classList.add('opacity-80', 'cursor-not-allowed');
            if (contactIcon) contactIcon.classList.add('hidden');
            if (contactSpinner) contactSpinner.classList.remove('hidden');
            if (contactBtnText) contactBtnText.innerText = 'Sending...';
        });
    }

    // 7. Header scroll effects — wrapper is always fixed, just toggle shadow + CTA + logo position
    const siteHeader = document.getElementById('site-header');
    const logoContainer = document.getElementById('logo-container');
    const stickyCta = document.getElementById('sticky-cta');
    const announcementBar = document.getElementById('announcement-bar');
    const headerNav = document.getElementById('header-nav');
    const headerLogo = document.getElementById('header-logo');
    let isScrolled = false;

    function handleHeaderScroll() {
        if (!siteHeader) return;
        const scrollY = window.scrollY || window.pageYOffset;
        const threshold = announcementBar ? announcementBar.offsetHeight : 40;

        if (scrollY > threshold) {
            if (!isScrolled) {
                isScrolled = true;
                siteHeader.classList.add('shadow-md', 'backdrop-blur-xl');

                if (stickyCta) {
                    stickyCta.classList.remove('hidden');
                    stickyCta.classList.add('inline-flex');
                }
                if (logoContainer) {
                    logoContainer.classList.remove('left-4');
                    logoContainer.classList.add('left-1/2', '-translate-x-1/2');
                }
                if (headerNav) {
                    headerNav.classList.remove('py-3', 'md:py-4');
                    headerNav.classList.add('py-1.5', 'md:py-2');
                }
                if (headerLogo) {
                    headerLogo.classList.remove('text-3xl', 'md:text-4xl');
                    headerLogo.classList.add('text-2xl', 'md:text-3xl');
                }
            }
        } else {
            if (isScrolled) {
                isScrolled = false;
                siteHeader.classList.remove('shadow-md', 'backdrop-blur-xl');

                if (stickyCta) {
                    stickyCta.classList.add('hidden');
                    stickyCta.classList.remove('inline-flex');
                }
                if (logoContainer) {
                    logoContainer.classList.remove('left-1/2', '-translate-x-1/2');
                    logoContainer.classList.add('left-4');
                }
                if (headerNav) {
                    headerNav.classList.add('py-3', 'md:py-4');
                    headerNav.classList.remove('py-1.5', 'md:py-2');
                }
                if (headerLogo) {
                    headerLogo.classList.add('text-3xl', 'md:text-4xl');
                    headerLogo.classList.remove('text-2xl', 'md:text-3xl');
                }
            }
        }
    }

    window.addEventListener('scroll', handleHeaderScroll, { passive: true });
    handleHeaderScroll();
});
